import React from 'react';

function Features() {
  return (
    <section className="tc-more-features">
      <div className="container">
        <div className="title text-center js-splittext-lines">
          <h2 className="fsz-45 fw-600 mb-30"> Why Choose Us </h2>
          <div className="text fsz-16 mb-60 color-666">
            We are committed to providing the best interior decor solutions. <br />
            Transform your space with our premium Delby products.
          </div>
        </div>
        <div className="cards">
          <div className="row justify-content-center">
            <div className="col-lg-3">
              <div
                className="feat-card wow fadeInUp slow"
                data-wow-delay="0.2s"
              >
                <div className="icon">
                  <i className="fal fa-shield-check"></i>
                </div>
                <div className="info">
                  <h5 className="fsz-24 mb-15"> Premium Quality </h5>
                  <p className="fsz-13 color-666">
                    High-quality PVC and WPC materials <br /> for long-lasting
                    durability and elegance.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div
                className="feat-card wow fadeInUp slow"
                data-wow-delay="0.4s"
              >
                <div className="icon">
                  <i className="fal fa-tools"></i>
                </div>
                <div className="info">
                  <h5 className="fsz-24 mb-15"> Easy Installation </h5>
                  <p className="fsz-13 color-666">
                    Quick and seamless installation process <br /> for all our
                    wall panels and louvers.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div
                className="feat-card wow fadeInUp slow"
                data-wow-delay="0.6s"
              >
                <div className="icon">
                  <i className="fal fa-palette"></i>
                </div>
                <div className="info">
                  <h5 className="fsz-24 mb-15"> Versatile Designs </h5>
                  <p className="fsz-13 color-666">
                    A wide variety of textures, colors, <br /> and finishes to
                    match your unique style.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
